<template>
  <!-- The planner's "Warnings on route" panel: the POI/hazard sheet shell, at
       the map's top-right (a bottom sheet on a phone). A hazard row opens the
       hazard; a difficult section's row shows the section on the map. -->
  <div v-if="open" class="route-alerts-sheet">
    <div
      class="poi-sheet__dialog route-alerts-sheet__dialog"
      :style="panelStyle"
      role="dialog"
      aria-modal="false"
      :aria-label="$t('route_alerts.sheet_title')"
      data-test="route-alerts-sheet"
    >
      <div class="poi-sheet__content">
        <div class="poi-sheet__handle" aria-hidden="true"></div>
        <header class="poi-sheet__header">
          <h2 class="route-alerts-sheet__title">{{ $t('route_alerts.sheet_title') }}</h2>
          <div class="poi-sheet__tools">
            <button
              type="button"
              class="poi-icon-btn"
              data-test="route-alerts-sheet-close"
              :aria-label="$t('shared.close')"
              @click="$emit('close')"
            >
              <span class="material-icons">close</span>
            </button>
          </div>
        </header>
        <div class="poi-sheet__body route-alerts-sheet__body">
          <RouteAlertList :rows="rows" @select="(row) => $emit('select', row)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import RouteAlertList from './RouteAlertList.vue';
import type { RouteAlertRowView } from '../../../utils/routeAlerts/routeAlertsModel';

export default defineComponent({
  name: 'RouteAlertsSheet',
  components: { RouteAlertList },
  props: {
    open: { type: Boolean, default: false },
    rows: { type: Array as PropType<RouteAlertRowView[]>, required: true },
    panelStyle: { type: Object as PropType<Record<string, string> | null>, default: null },
  },
  emits: ['close', 'select'],
});
</script>

<style scoped>
/* Under the hazard details (1056), which opens from a row in the same spot. */
.route-alerts-sheet__dialog {
  z-index: 1054;
}

.route-alerts-sheet__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
}

.route-alerts-sheet__body {
  padding-top: 0.25rem;
  padding-bottom: 0.75rem;
}
</style>
